import { Header } from "./Header"

export const Navigation = {
	getLinks: () => document.querySelectorAll('.navigation-links a'), 
	
  currentLink: (current) => {
		const links = Navigation.getLinks()
		const removeHash = element => element.replace("#", '')

		links.forEach( link => {

			if(removeHash(link.getAttribute('href')) === current) {
				link.classList.add('is-active')
			} else {
				link.classList.remove('is-active')
			}
		})
  },

}